module.exports = __webpack_public_path__ + "static/media/contentApp2AppTravelIcon.eb552872.svg";